import { RULE_FORM_ERRORS } from '@/config/rule';

export const validateActionDelay = async (delay: unknown): Promise<boolean> => {
  if (delay === undefined || delay === null || delay === '') {
    return true;
  }

  const parsedDelay = Number(delay);
  if (!Number.isFinite(parsedDelay) || parsedDelay <= 0) {
    throw new Error(RULE_FORM_ERRORS.RULE_ACTION_DELAY_INVALID);
  }

  return true;
};
